$(document).on('click', '[data-behavior~="admin-reimpersonate"]', function () {
  Turbolinks.clearCache()
})
